import React from "react";
import { Helmet } from "react-helmet";
import { generateBreadcrumbSchema } from "../../utils/generate-breadcrumb-schema";

interface BreadcrumbSchemaProps {
  pathname: string;
  pageTitle?: string;
}

export const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({
  pathname,
  pageTitle,
}) => {
  const breadcrumbSchema = generateBreadcrumbSchema(pathname, pageTitle);

  if (!breadcrumbSchema) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
